// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3Bqo5","col":"styles_col__3e92s","fulfillmentStatus":"styles_fulfillmentStatus__2Yb2b","emailCol":"styles_emailCol__1yHT-"};